/**
 * Tearing down the LOCAL player's body — on a new `world_init` and on a
 * practice-room character change.
 *
 * The same four things the remote-player removal path does (RemotePlayers.
 * removeRemotePlayer), in the same order: out of the scene, the pose driver,
 * the status aura, the materials. Pass 3 made every aura part a POOLED shape,
 * and this path did not return them — a Walled Garden live at a world change
 * had its shell destroyed with the body's materials instead of released, and
 * the aura tracker kept the dead body forever. One function, so the two
 * paths cannot drift again.
 */

import { disposeBodyMaterials } from './RemotePlayers.js';
import { disposeStatusAura } from '../combat/StatusAura.js';

/** @param {import('three').Object3D | null} mesh the body; a null is a no-op */
export function disposeLocalBody(mesh) {
  if (!mesh) return false;
  mesh.parent?.remove(mesh);
  mesh.userData?.driver?.dispose?.();
  disposeStatusAura(mesh);
  disposeBodyMaterials(mesh);
  return true;
}
